import React, { useState, useEffect, useRef } from "react";
import HeaderTwo from "../components/header2";
import styles from "../styles/register.module.css";
import { ReactComponent as ChevronRight } from '../svg/chevron-right-solid-black.svg';
import { ReactComponent as ChevronLeft } from '../svg/chevron-left-solid-black.svg';
import { Button } from "@mui/material";
import Footer from "../components/footer";
import CircularProgress from '@mui/material/CircularProgress';
import { CircularProgress as JoyCircularProgress } from "@mui/joy";
import { useNavigate } from "react-router-dom";
import SpeedDialComponent from "../control/speeddial";
import { useMediaQuery } from "react-responsive";
import ReactGa from "react-ga4";
import { track, getDistinctId, getAttributionProps, identifyFamily } from '../lib/mixpanel';
import { each, set } from "lodash";
import { start } from "repl";
import { Modal, Sheet, Typography } from "@mui/joy";
import { englishLocationToKorean } from "./dailyreport/functions/etcfunction";
import { ReactComponent as Check } from "../svg/3dchecksvg.svg";
import { ReactComponent as BackArrow } from "../svg/backarrowsvg.svg";
import { ArrowBack, ContentCopy } from "@mui/icons-material";


// const startDate = new Date();




const weeks = [1, 2, 3, 4, 5, 6];
var intervalId: any;

const weekString = ["일", "월", "화", "수", "목", "금", "토"];


const RegisterLink: React.FC<any> = (props) => {

    // const startDueDateValue = new Date(2025, 10, 17);

    const [location, setLocation] = useState("gangnam");

    const [name, setName] = useState("");

    const [studentFullTelephone, setStudentFullTelephone] = useState(false);
    const [parentFullTelephone, setParentFullTelephone] = useState(false);

    const [studentPhoneNumber, setStudentPhoneNumber] = useState("");
    const [parentPhoneNumber, setParentPhoneNumber] = useState("");

    const [whichCertify, setWhichCertify] = useState("student");

    //클릭 안된 상태, 클릭 한 상태
    const [certifyClicked, setCertifyClicked] = useState<boolean>(false);
    const [remainTime, setRemainTime] = useState(0);
    const [certifyCorrect, setCertifyCorrect] = useState<any>(null);
    const [certNumber, setCertNumber] = useState();


    const studentPhoneNumberInputRef = useRef<any>(null);
    const parentPhoneNumberInputRef = useRef<any>(null);
    const certNumberInputRef = useRef<any>(null);

    const [submitLoading, setSubmitLoading] = useState(false);

    const [disabled, setDisabled] = useState(true);

    const [data, setData] = useState<any>(null);

    const [open, setOpen] = useState(false);
    const [id, setId] = useState<number | null>(null);
    const [code, setCode] = useState<number | null>(null);

    const [paymentMethod, setPaymentMethod] = useState<string>("payteacher");

    const [page, setPage] = useState<number>(1);


    const [bankInfo, setBankInfo] = useState<any>(null);
    const [dueDate, setDueDate] = useState<Date | null>(null);
    const eachRef = useRef<any>(new Array());

    //가로 세로 길이 같게 만드는-----------------------------------------

    const [selectedEndIndex, setSelectedEndIndex] = useState("");
    const [text, setText] = useState("");


    const [receiptFile, setReceiptFile] = useState<File | null>(null);
    const [receiptPreview, setReceiptPreview] = useState<string>("");
    const [receiptUploading, setReceiptUploading] = useState(false);
    const [receiptUploaded, setReceiptUploaded] = useState(false);
    const [receiptError, setReceiptError] = useState<string>("");

    const [realFinishLoading, setRealFinishLoading] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [page]);

    const [finalPrice, setFinalPrice] = useState<{
        price: number,
        discount: number,
        finalPrice: number
    }>({
        price: 0,
        discount: 0,
        finalPrice: 0
    });

    const [dueDateRemain, setDueDateRemain] = useState<string>("");

    useEffect(() => {
        if (!dueDate) return;

        const tick = () => {
            const now = new Date().getTime();
            const end = new Date(dueDate).getTime();
            const diff = end - now;

            if (diff <= 0) {
                setDueDateRemain("00:00:00");
                setText("만료된 링크입니다.");
                setOpen(true);
                return;
            }

            const h = String(Math.floor(diff / (1000 * 60 * 60))).padStart(2, "0");
            const m = String(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, "0");
            const s = String(Math.floor((diff % (1000 * 60)) / 1000)).padStart(2, "0");
            setDueDateRemain(`${h}:${m}:${s}`);
        };

        tick();
        const id = setInterval(tick, 1000);
        return () => clearInterval(id);
    }, [dueDate]);


    useEffect(() => {

        if (studentFullTelephone && parentFullTelephone && certifyCorrect === "success" && name.length > 0) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }

    }, [studentFullTelephone, parentFullTelephone, certifyCorrect, name]);




    //ga event------------------------------------------------
    useEffect(() => {

        ReactGa.send({
            hitType: "pageview",
            page_title: "register"
        });

    }, []);
    //--------------------------------------------------------

    useEffect(() => {

    }, [])


    const typeName = (e: any) => {
        setName(e.target.value);
    }

    const typeTelephone = (e: any, type: string) => {
        console.log(e.target.value);

        if (certifyCorrect === "success" && (whichCertify === type)) {
            console.log("already");
            return;
        }

        e.target.value = e.target.value.replace(/[^\d]+/g, "");

        if (e.target.value.length > 11) {
            return;
        }

        if (type === "student") {
            setStudentPhoneNumber(e.target.value);
        } else {
            setParentPhoneNumber(e.target.value);
        }

        if (e.target.value.length === 11) {
            if (type === "student") {
                setStudentFullTelephone(true);
            } else {
                setParentFullTelephone(true);
            }
            if (parentPhoneNumberInputRef.current) {
                parentPhoneNumberInputRef.current.blur();
            }
            if (studentPhoneNumberInputRef.current) {
                studentPhoneNumberInputRef.current.blur();
            }
        } else {
            if (type === "student") {
                setStudentFullTelephone(false);
            } else {
                setParentFullTelephone(false);
            }
        }
    }


    const typeCert = (e: any) => {
        console.log(e.target.value);
        e.target.value = e.target.value.replace(/[^\d]+/g, "");

        if (e.target.value.length > 6) {
            console.log(111);
            return;
        }

        if (e.target.value.length !== 6) {
            setCertifyCorrect(null);
        }

        setCertNumber(e.target.value);

        if (e.target.value.length === 6) {

            fetch(`https://suneungsunbae.com/api/booking/cert`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    telephoneNumber: whichCertify === "student" ? studentPhoneNumber : parentPhoneNumber,
                    certNumber: e.target.value
                })
            }).then((response: any) => {
                response.json()
                    .then((result: any) => {
                        console.log(result);
                        if (result.message !== "success") {
                            setCertifyCorrect("fail");
                            track('Phone Verification Failed', { form_type: 'payment', payment_id: id });
                        } else {
                            setCertifyCorrect("success");
                            track('Phone Verification Succeeded', { form_type: 'payment', payment_id: id });
                            if (certNumberInputRef.current) {
                                certNumberInputRef.current.blur();
                            }
                        }
                    })
            }
            )
        }

    }


    const getCert = (e: any, type: string) => {
        if (!studentFullTelephone && !parentFullTelephone) {
            console.log("morenumber");
            return;
        }

        if (certifyClicked && type === "btn") {
            console.log("reclick");
            return;
        }

        if (intervalId) {
            clearInterval(intervalId);
        }



        track('Phone Verification Requested', {
            retry: type === 'rebtn',
            which_phone: whichCertify,
            form_type: 'payment',
            payment_id: id,
        });
        setCertifyClicked(true);
        setCertifyCorrect(null);

        certNumberInputRef.current.focus();

        var remain = 300;

        setRemainTime(300);

        intervalId = setInterval(() => {
            if (remain > -1) {
                setRemainTime(remain);
                remain--;
            }
        }, 1000);


        fetch(`https://suneungsunbae.com/api/booking/cert?telephoneNumber=${whichCertify === "student" ? studentPhoneNumber : parentPhoneNumber}`, {
            method: "GET"
        }).then((response: any) => {
            response.json()
                .then((result: any) => {
                    console.log(result);
                })
        }
        )
    }

    const submit = async () => {

        try {

            const data = {
                name: name,
                studentPhoneNumber,
                parentPhoneNumber,
                id,
                paymentMethod,
                whichCertify
            }

            if (!data.name || !data.studentPhoneNumber || !data.parentPhoneNumber || !data.id) {
                return;
            }

            console.log(data);

            identifyFamily(studentPhoneNumber, parentPhoneNumber, {
                '$name': name,
                'last_payment_location': location,
                'verified_via': whichCertify,
            });
            track('Payment Started', {
                payment_id: id,
                payment_method: paymentMethod,
                location: location,
                which_certify: whichCertify,
            });

            setSubmitLoading(true);

            const reponse: any = await fetch("https://peetsunbae.com/dashboard/payments/createlinkpayment", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    ...data,
                    mp_distinct_id: getDistinctId(),
                    mp_attribution: getAttributionProps(),
                })
            });

            const result = await reponse.json();
            console.log(result);

            setSubmitLoading(false);
            console.log(result.message);

            if (result.otherMethod) {
                track('Payment Bank Info Shown', {
                    payment_id: id,
                    payment_method: paymentMethod,
                });
                setPage(2);
                return;
            }

            if (result.message === "isDestroy") {
                alert("파기된 링크입니다.");
                track('Payment Submit Failed', { reason: 'is_destroy', payment_id: id });
                return;
            }

            if (result.message === "isPaid") {
                alert("이미 결제된 링크입니다.");
                track('Payment Submit Failed', { reason: 'already_paid', payment_id: id });
                return;
            }

            if (result.message === "isLate") {
                alert("만료된 링크입니다.");
                track('Payment Submit Failed', { reason: 'expired', payment_id: id });
                return;
            }

            if (result.message === "fail" || result.message === "error") {
                alert("오류 관리자 문의(010-9880-0489)")
                track('Payment Submit Failed', { reason: result.message, payment_id: id });
            }
            if (result.message === "success") {
                const shortURL = result.shortURL;

                if (shortURL) {
                    console.log(shortURL);
                    track('Payment Card Redirect', {
                        payment_id: id,
                        payment_method: 'card',
                    });
                    window.location.href = shortURL;
                }

            }

        } catch (e) {
            console.log(e);
            track('Payment Submit Failed', { reason: 'exception', error: String(e), payment_id: id });
        }

    }

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);

        const idRaw = params.get("id");
        const codeRaw = params.get("code");

        const id = Number(idRaw);
        const code = Number(codeRaw);

        console.log("id:", idRaw, "=>", id);
        console.log("code:", codeRaw, "=>", code);

        // 값이 없거나 숫자가 아니면 막기
        if (!idRaw || !codeRaw || Number.isNaN(id) || Number.isNaN(code)) {
            setText("잘못된 접근입니다. (invalid parameters)");
            setOpen(true);
            track('Payment Link Access Failed', { reason: 'invalid_parameters' });
            return;
        }

        // 검증: code === id * 500 + 10
        if (code !== id * id + id * 500 + 10) {
            setText("잘못된 접근입니다. (code mismatch)");
            setOpen(true);
            track('Payment Link Access Failed', { reason: 'code_mismatch' });
            return;
        }

        // 여기까지 오면 통과
        setId(id);
        setCode(code);
        track('Payment Page Viewed', { payment_id: id });
        getData(id, code);

    }, []);



    const getData = async (id: number, code: number) => {

        try {

            const reponse: any = await fetch("https://peetsunbae.com/dashboard/payments/getlinkpaymentdata?id=" + id + "&code=" + code, {
                method: "GET"
            });

            const result = await reponse.json();
            console.log(result);


            if (result.message === "expired") {
                setText("만료된 링크입니다.");
                setOpen(true);
                track('Payment Link Access Failed', { reason: 'expired', payment_id: id });
                return;
            }

            if (result.message === "error") {
                setText("잘못된 접근입니다. (server error)");
                setOpen(true);
                track('Payment Link Access Failed', { reason: 'server_error', payment_id: id });
                return;
            }

            if (result.message === "noValidCode") {
                setText("잘못된 접근입니다. (invalid code)");
                setOpen(true);
                track('Payment Link Access Failed', { reason: 'invalid_code', payment_id: id });
                return;
            }

            if (result.message === "alreadyPaid") {
                setText("이미 결제된 링크입니다.");
                setOpen(true);
                track('Payment Link Access Failed', { reason: 'already_paid', payment_id: id });
                return;
            }

            if (result.message === "destroyed") {
                setText("파기된 링크입니다.");
                setOpen(true);
                track('Payment Link Access Failed', { reason: 'destroyed', payment_id: id });
                return;
            }

            if (result.message === "success") {
                setData(result.data);
                setLocation(result.data.location);
                setBankInfo(result.bankinfo);
                setDueDate(new Date(result.dueDate));

                if (result.isAlready) {
                    setName(result.studentName);
                    setStudentPhoneNumber(result.studentPhoneNumber);
                    setParentPhoneNumber(result.parentPhoneNumber);
                    setStudentFullTelephone(true);
                    setParentFullTelephone(true);
                    setWhichCertify(result.whichCertify);
                    if (result.paymentMethod) {
                        setPaymentMethod(result.paymentMethod);
                    }
                    if (!result.isFinish) {
                        setPage(2);
                    } else {
                        setPage(3);
                    }
                }

                track('Payment Info Loaded', {
                    payment_id: id,
                    location: result.data.location,
                    price: result.data.price,
                    is_already: !!result.isAlready,
                    resumed_at_page: result.isAlready ? (result.isFinish ? 3 : 2) : 1,
                });

            }


        } catch (e) {
            console.log(e);
        }

    }

    const copyToClipboard = async () => {
        if (!bankInfo?.accountNumber) return;

        const text = `${bankInfo.bankName}\n${bankInfo.accountNumber}`;

        try {
            await navigator.clipboard.writeText(text);
            alert("계좌번호가 복사되었습니다.");
        } catch (err) {
            console.error("복사 실패:", err);
        }
    };


    const UPLOAD_URL = "https://peetsunbae.com/dashboard/payments/uploadpaylinkimg";
    // TODO: 네 서버 엔드포인트로 교체

    const uploadReceiptOnly = async (file: File) => {
        if (!id) {
            setReceiptError("잘못된 접근입니다. (missing id)");
            return;
        }

        track('Receipt Upload Started', {
            payment_id: id,
            payment_method: paymentMethod,
            file_size: file.size,
        });

        try {
            setReceiptError("");
            setReceiptUploading(true);
            setReceiptUploaded(false);

            const form = new FormData();
            form.append("file", file);
            // form.append("id", String(id));      // ✅ 사진만 + 매칭용 id
            // form.append("paymentMethod", paymentMethod);
            // form.append("code", String(code)); // (원하면 같이)

            form.append("data", JSON.stringify({
                id: id,
                paymentMethod: paymentMethod,
                code: code
            }));


            const resp = await fetch(UPLOAD_URL, {
                method: "POST",
                body: form,
            });



            const result = await resp.json();

            if (result.message === "notFound") {
                alert("잘못된 접근입니다. (not found)");
                track('Receipt Upload Failed', { reason: 'not_found', payment_id: id });
                return;
            }

            if (result.message === "destroyed") {
                alert("파기된 링크입니다.");
                track('Receipt Upload Failed', { reason: 'destroyed', payment_id: id });
                return;
            }

            if (result.message === "expired") {
                alert("만료된 링크입니다.");
                track('Receipt Upload Failed', { reason: 'expired', payment_id: id });
                return;
            }


            if (result.message !== "success") throw new Error(result.message);

            setReceiptUploaded(true);
            track('Receipt Uploaded', { payment_id: id, payment_method: paymentMethod });
        } catch (e) {
            setReceiptError("업로드에 실패했어요. 다시 시도해주세요.");
            setReceiptUploaded(false);
            track('Receipt Upload Failed', { reason: 'exception', payment_id: id });
        } finally {
            setReceiptUploading(false);
        }
    };

    const onPickReceipt = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        setReceiptFile(file);

        const previewUrl = URL.createObjectURL(file);
        setReceiptPreview(previewUrl);

        await uploadReceiptOnly(file);
    };

    useEffect(() => {
        return () => {
            if (receiptPreview) URL.revokeObjectURL(receiptPreview);
        };
    }, [receiptPreview]);


    const realFinish = async () => {

        try {

            track('Payment Finish Clicked', {
                payment_id: id,
                payment_method: paymentMethod,
            });
            setRealFinishLoading(true);

            const response = await fetch("https://peetsunbae.com/dashboard/payments/finishlinkpayment", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    id,
                    code,
                })
            });

            const result = await response.json();

            if (result.message === "success") {
                track('Payment Self Reported', {
                    payment_id: id,
                    payment_method: paymentMethod,
                });
                setPage(3);
            }

        } catch (e) {
            console.log(e);
        }

    }



    return (
        <div>
            {
                !data &&
                <div style={{
                    width: "100%",
                    height: "80vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <JoyCircularProgress size="lg" thickness={6} />
                </div>
            }
            {
                (page === 1 && data)
                &&
                <div className={styles.formBody}>
                    <>
                        <div className={styles.titleText}>
                            1분 안에<br></br>등록 처리 해드릴게요!
                        </div>

                        {/* 여기에 추가 */}
                        {dueDateRemain && (
                            <div style={{
                                backgroundColor: "#1B49AF1F",
                                borderRadius: "8px",
                                padding: "11px 20px",
                                textAlign: "center",
                                marginTop: "49px",
                                marginBottom: "49px",
                                fontSize: "16px",
                                color: "#1B49af",
                                fontFamily: "Apple_R",
                                fontWeight: "500"
                            }}>
                                결제링크 만료까지 <span style={{ fontFamily: "Apple_R", color: "#1b49af", fontWeight: "700" }}>{dueDateRemain}</span> 남았어요
                            </div>
                        )}

                        <div className={`${styles.questionText} ${styles.third}`}>
                            간단한 정보만 적어주세요
                        </div>

                        <div className={styles.inputWrapper}>
                            <div className={styles.inputDiv}>
                                <input value={name} onChange={typeName} placeholder="학생 이름을 적어주세요" className={styles.input} type="text">

                                </input>
                            </div>

                            <div className={styles.inputDiv} style={{
                                marginTop: "22px"
                            }}>
                                <input ref={studentPhoneNumberInputRef} pattern="\d*" value={studentPhoneNumber} onChange={(e) => { typeTelephone(e, "student") }} placeholder="학생 핸드폰번호를 적어주세요" className={styles.input} type="tel">

                                </input>
                            </div>


                            <div className={styles.inputDiv} style={{
                                marginTop: "22px"
                            }}>
                                <input ref={parentPhoneNumberInputRef} pattern="\d*" value={parentPhoneNumber} onChange={(e) => { typeTelephone(e, "parent") }} placeholder="학부모 핸드폰번호를 적어주세요" className={styles.input} type="tel">

                                </input>
                            </div>


                            <div className={`${styles.questionText} ${styles.first}`}>
                                어떤 번호로 인증을 받으시겠어요?
                            </div>
                            <div className={styles.selectDiv}>
                                <div onClick={(e: any) => {

                                    if (certifyCorrect === "success") {
                                        console.log("already");
                                        return;
                                    }

                                    setWhichCertify("student");
                                }} className={`${styles.select} ${whichCertify === "student" ? styles.active : ""}`}>
                                    학생번호
                                </div>
                                <div onClick={(e: any) => {

                                    if (certifyCorrect === "success") {
                                        console.log("already");
                                        return;
                                    }

                                    setWhichCertify("parent");
                                }} className={`${styles.select} ${whichCertify === "parent" ? styles.active : ""}`}>
                                    학부모번호
                                </div>
                            </div>



                            <div className={styles.telephoneDiv}>
                                <div className={styles.telephoneInputDiv}>
                                    <input pattern="\d*" value={whichCertify === "student" ? studentPhoneNumber : parentPhoneNumber} onChange={(e) => { return; }} placeholder="" className={styles.telephoneInput} type="tel">

                                    </input>
                                </div>
                                <div className={styles.telephoneBtnDiv}>
                                    <div onClick={(e: any) => { getCert(e, "btn") }} className={`${styles.certBtn} ${((whichCertify === "student" ? studentFullTelephone : parentFullTelephone) && !certifyClicked) ? styles.active : ""}`}>
                                        {
                                            !certifyClicked &&
                                            <span className={styles.btnText}>
                                                인증번호 받기
                                            </span>
                                        }
                                        {
                                            (certifyClicked) &&
                                            <span className={styles.btnText}>
                                                0
                                                {Math.floor(remainTime / 60)}
                                                :
                                                {
                                                    remainTime % 60 < 10 ?
                                                        "0" + remainTime % 60 : remainTime % 60
                                                }
                                            </span>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className={`${styles.inputDiv} ${styles.cert}`}>
                                <input ref={certNumberInputRef} pattern="\d*" value={certNumber} onChange={typeCert} placeholder="인증번호를 입력해주세요" className={styles.input} type="tel">

                                </input>
                            </div>
                            <div className={styles.certText}>
                                {
                                    (certifyClicked && !certifyCorrect) &&
                                    <>
                                        인증번호가 발송되었습니다 <span className={styles.recert} onClick={(e: any) => { getCert(e, "rebtn") }}>&nbsp;&nbsp;&nbsp;&nbsp;재전송하기</span>
                                    </>
                                }
                                {
                                    (certifyClicked && certifyCorrect === "fail") &&
                                    <>
                                        <span className={styles.certifyFail}>
                                            잘못된 인증번호입니다.
                                        </span>
                                        <span className={styles.recert2} onClick={(e: any) => { getCert(e, "rebtn") }}>&nbsp;&nbsp;&nbsp;&nbsp;재전송하기</span>
                                    </>
                                }
                                {
                                    (certifyClicked && certifyCorrect === "success") &&
                                    <>
                                        <span className={styles.certifySuccess}>
                                            핸드폰인증에 성공했습니다.
                                        </span>
                                    </>
                                }
                            </div>

                            <div className={`${styles.questionText} ${styles.first}`}>
                                결제수단
                            </div>
                            <div>
                                <div className={styles.selectDiv} style={{
                                    marginBottom: "10px"
                                }}>
                                    {/* <div onClick={(e: any) => {
                                        setPaymentMethod("payteacher");
                                    }} className={`${styles.select} ${paymentMethod === "payteacher" ? styles.active : ""}`}>
                                        <img src="img/payteacherlogo.webp"
                                            style={{
                                                width: "110px"
                                            }}
                                        />
                                    </div> */}
                                    <div onClick={(e: any) => {
                                        setPaymentMethod("payteacher");
                                        track('Payment Method Selected', { method: 'card', payment_id: id });
                                    }} className={`${styles.select} ${paymentMethod === "payteacher" ? styles.active : ""}`}>
                                        카드 결제
                                    </div>
                                    <div onClick={(e: any) => {
                                        setPaymentMethod("withdrawal");
                                        track('Payment Method Selected', { method: 'bank_transfer', payment_id: id });
                                    }} className={`${styles.select} ${paymentMethod === "withdrawal" ? styles.active : ""}`}>
                                        계좌이체
                                    </div>
                                </div>
                                <div className={styles.selectDiv}>

                                    <div onClick={(e: any) => {
                                        setPaymentMethod("onSite");
                                        track('Payment Method Selected', { method: 'on_site', payment_id: id });
                                    }} className={`${styles.select} ${paymentMethod === "onSite" ? styles.active : ""}`}>
                                        현장결제
                                    </div>
                                    <div onClick={(e: any) => {
                                        setPaymentMethod("local");
                                        track('Payment Method Selected', { method: 'local_currency', payment_id: id });
                                    }} className={`${styles.select} ${paymentMethod === "local" ? styles.active : ""}`}>
                                        지역화폐
                                    </div>
                                </div>
                            </div>


                        </div>


                        <>
                            <div className={`${styles.questionText} ${styles.second}`}>
                                아래 내용이 맞는지 확인해주세요
                            </div>
                            <div className={styles.descriptionBox}>
                                <div className={styles.descriptionBoxTitle}>
                                    등록비 내역
                                </div>
                                <div className={styles.desciptionBoxText} style={{
                                    marginBottom: "30px"
                                }}>
                                    <div className={styles.descriptionBoxTextItem1}>
                                        지점
                                    </div>
                                    <div className={styles.descriptionBoxTextItem2}>
                                        {
                                            englishLocationToKorean(location)
                                        }
                                    </div>
                                </div>
                                <div className={styles.desciptionBoxText}>
                                    <div className={styles.descriptionBoxTextItem1}>
                                        일정
                                    </div>
                                    <div className={styles.descriptionBoxTextItem2}>
                                        {
                                            `
                                            ${new Date(data.startDate).getMonth() + 1}월 ${new Date(data.startDate).getDate()}일 ~ ${new Date(data.endDate).getMonth() + 1}월 ${new Date(data.endDate).getDate()}일
                                            `
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className={styles.resultBox}>
                                <div className={styles.resultBoxTitle}>
                                    총액
                                </div>
                                <div className={styles.resultBoxPriceDiv}>
                                    <div className={styles.resultBoxFinalPrice}>
                                        {data.price.toLocaleString()}원
                                    </div>
                                </div>
                            </div>
                        </>


                        <div className={styles.submitBtnDiv} style={{
                            marginTop: "48px"
                        }}>
                            <Button
                                disabled={disabled || submitLoading} onClick={submit} variant="contained" fullWidth sx={{ height: "72px", borderRadius: "12px", backgroundColor: "#1b49af", color: "white", fontWeight: 700, fontSize: "20px", "&:hover": { backgroundColor: "#153a8a" }, "@media (max-width : 1024px)": { fontSize: "16px", height: '55.5px' } }}
                            >
                                {
                                    submitLoading ?
                                        <span style={{
                                            color: "white"
                                        }}>
                                            <CircularProgress size={32} color="inherit" />
                                        </span>
                                        :
                                        <span>결제하기</span>
                                }
                            </Button>
                        </div>

                        <div style={{
                            border: "1px solid #dedede",
                            borderRadius: "12px",
                            padding: "20px",
                            marginTop: "30px",
                        }}>
                            <div style={{
                                color: "#aaaaaa",
                                fontWeight: 500,
                                marginBottom: "14px",
                                fontSize: "14px"
                            }}>
                                신규생 결제 안내
                            </div>
                            <div style={{
                                color: "#aaaaaa",
                                marginBottom: "8px",
                                fontSize: "14px"
                            }}>
                                ※ 환불규정은 학원법 제 18조 3항에 따라 적용됩니다.
                            </div>
                            <div style={{
                                color: "#aaaaaa",
                                fontSize: "14px"
                            }}>
                                ※ 결제수단 변경은 등록기간 종료 전까지 가능합니다.
                            </div>
                        </div>

                    </>
                </div>
            }
            {
                (page === 2 && data)
                &&
                <div className={styles.formBody}>
                    <div>
                        <div style={{
                            paddingTop: "5px"
                        }}>
                            <div style={{
                                padding: "15px",
                                paddingLeft: "0px",
                            }}
                                onClick={() => {
                                    setPage(1);
                                }}
                            >
                                <BackArrow />
                            </div>
                        </div>
                        <div style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: "40px",
                            marginBottom: "15px"
                        }}>
                            <Check style={{
                                width: "65px"
                            }} />
                        </div>
                        <div style={{
                            color: "#272727",
                            fontFamily: "Apple_EB",
                            fontWeight: 700,
                            fontSize: "24px",
                            textAlign: "center",
                            lineHeight: 1.5
                        }}>
                            기한 내 결제 완료 시<br />등록이 완료됩니다
                        </div>
                        {/* 여기에 추가 */}
                        {dueDateRemain && (
                            <div style={{
                                backgroundColor: "#1B49AF1F",
                                borderRadius: "8px",
                                padding: "11px 20px",
                                textAlign: "center",
                                marginTop: "49px",
                                fontSize: "16px",
                                color: "#1B49af",
                                fontFamily: "Apple_R",
                                fontWeight: "500"
                            }}>
                                결제링크 만료까지 <span style={{ fontFamily: "Apple_R", color: "#1b49af", fontWeight: "700" }}>{dueDateRemain}</span> 남았어요
                            </div>
                        )}
                        <div style={{
                            paddingTop: "44px"
                        }}>
                            <div style={{
                                color: "#353535",
                                fontFamily: "Apple_B",
                                fontWeight: 600
                            }}>
                                {
                                    paymentMethod === "withdrawal" &&
                                    "계좌이체"
                                }
                                {
                                    paymentMethod === "onSite" &&
                                    "현장결제"
                                }
                                {
                                    paymentMethod === "local" &&
                                    "지역화폐"
                                }
                            </div>
                            <div
                                style={{
                                    borderBottom: "2px solid black",
                                    width: "100%",
                                    marginTop: "16px",
                                    marginBottom: "16px"
                                }}
                            />
                            <div style={{
                                border: "1px solid #dedede",
                                borderRadius: "12px",
                                paddingTop: "30px",
                                paddingBottom: "30px",
                                paddingLeft: "15px",
                                paddingRight: "15px",
                                width: "100%"
                            }}>
                                <div style={{
                                    fontSize: "20px",
                                    fontWeight: 500
                                }}>
                                    {
                                        data.price.toLocaleString() + "원"
                                    }
                                </div>
                                {
                                    paymentMethod === "withdrawal" &&
                                    <div style={{
                                        marginTop: "25px",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}>
                                        <div>
                                            {
                                                bankInfo &&
                                                bankInfo.bankName + " " + bankInfo.accountNumber
                                            }
                                        </div>
                                        <div onClick={() => {
                                            copyToClipboard();
                                        }}>
                                            <ContentCopy
                                                fontSize="small"
                                                style={{
                                                    color: "#353535",
                                                    fontSize: "18px"
                                                }}
                                            />
                                        </div>
                                    </div>
                                }
                                <div style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginTop: "25px",
                                    color: "#353535",
                                    fontWeight: 500
                                }}>
                                    <div>
                                        등록기한
                                    </div>
                                    <div>
                                        {
                                            dueDate &&
                                            `${dueDate.getMonth() + 1}월 ${dueDate.getDate()}일 ${String(dueDate.getHours()).padStart(2, '0')
                                            }시 ${String(dueDate.getMinutes()).padStart(2, '0')
                                            }분 까지`
                                        }

                                    </div>
                                </div>
                            </div>
                            {
                                paymentMethod === "onSite" &&
                                <>
                                    <div style={{
                                        marginTop: "32px",
                                        color: "#353535",
                                        fontFamily: "Apple_B",
                                        fontWeight: 600,
                                        lineHeight: 1.5
                                    }}>
                                        기한 내 학원에 방문하여 결제를 진행해 주시기 바랍니다. <br />기한 내 방문이 어려운 경우, 현장에서 결제 링크를 재요청해 주세요.
                                    </div>
                                </>
                            }
                            {
                                (paymentMethod === "withdrawal" || paymentMethod === "local") &&
                                <>
                                    <div style={{
                                        color: "#353535",
                                        fontFamily: "Apple_B",
                                        fontWeight: 600,
                                        marginTop: "42px"
                                    }}>
                                        {paymentMethod === "withdrawal" ? "등록기한 내에 이체내역을 캡처하여 업로드 해주세요" : "등록기한 내에 승인내역을 캡처하여 업로드 해주세요"}
                                    </div>
                                    <div
                                        style={{
                                            borderBottom: "2px solid black",
                                            width: "100%",
                                            marginTop: "16px",
                                            marginBottom: "16px"
                                        }}
                                    />

                                    <label
                                        style={{
                                            display: "block",
                                            border: "1px solid #dedede",
                                            borderRadius: "12px",
                                            padding: "18px",
                                            textAlign: "center",
                                            cursor: receiptUploading ? "not-allowed" : "pointer",
                                            background: "#fff",
                                            opacity: receiptUploading ? 0.7 : 1,
                                        }}
                                    >
                                        <input
                                            type="file"
                                            accept="image/*"
                                            // capture="environment"
                                            style={{ display: "none" }}
                                            onChange={onPickReceipt}
                                            disabled={receiptUploading}
                                        />

                                        {!receiptPreview ? (
                                            <>
                                                <div style={{ color: "#8a8a8a", fontWeight: 600, marginBottom: "10px" }}>
                                                    {paymentMethod === "withdrawal" ? "이체내역 업로드" : "승인내역 업로드"}
                                                </div>
                                                <div
                                                    style={{
                                                        width: "42px",
                                                        height: "42px",
                                                        borderRadius: "12px",
                                                        border: "1px solid #dedede",
                                                        margin: "0 auto",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        fontSize: "26px",
                                                        color: "#666",
                                                    }}
                                                >
                                                    +
                                                </div>
                                                <div style={{ marginTop: "12px", fontSize: "12px", color: "#9a9a9a" }}>
                                                    이미지를 선택하면 자동 업로드됩니다.
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                    <div style={{ fontWeight: 700, color: "#353535" }}>이체내역</div>
                                                    <div style={{ fontSize: "12px", color: "#9a9a9a" }}>
                                                        {receiptUploading ? "업로드 중..." : receiptUploaded ? "업로드 완료" : "업로드 실패"}
                                                    </div>
                                                </div>

                                                <div style={{ marginTop: "12px" }}>
                                                    <img
                                                        src={receiptPreview}
                                                        alt="receipt preview"
                                                        style={{
                                                            width: "100%",
                                                            borderRadius: "12px",
                                                            border: "1px solid #eee",
                                                            display: "block",
                                                        }}
                                                    />
                                                </div>

                                                <div style={{ marginTop: "10px", fontSize: "12px", color: "#9a9a9a" }}>
                                                    (다시 선택하려면 탭하세요)
                                                </div>
                                            </>
                                        )}
                                    </label>

                                    {receiptError && (
                                        <div style={{ marginTop: "10px", color: "#d64545", fontSize: "12px" }}>
                                            {receiptError}
                                        </div>
                                    )}


                                    <div className={styles.submitBtnDiv} style={{
                                        marginTop: "48px"
                                    }}>
                                        <Button
                                            disabled={!receiptUploaded}

                                            onClick={() => {
                                                realFinish();
                                            }} variant="contained" fullWidth sx={{ height: "72px", borderRadius: "12px", backgroundColor: "#1b49af", color: "white", fontWeight: 700, fontSize: "20px", "&:hover": { backgroundColor: "#153a8a" }, "@media (max-width : 1024px)": { fontSize: "16px", height: '55.5px' } }}
                                        >
                                            {
                                                realFinishLoading ?
                                                    <span style={{
                                                        color: "white"
                                                    }}>
                                                        <CircularProgress size={32} color="inherit" />
                                                    </span>
                                                    :
                                                    <span>결제했어요</span>
                                            }
                                        </Button>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
            }
            {
                (page === 3 && data)
                &&
                <div>
                    <div className={styles.formBody}>
                        <div>
                            <div style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "55px",
                                marginBottom: "15px"
                            }}>
                                <Check style={{
                                    width: "65px"
                                }} />
                            </div>
                            <div style={{
                                color: "#272727",
                                fontFamily: "Apple_EB",
                                fontWeight: 700,
                                fontSize: "24px",
                                textAlign: "center",
                                lineHeight: 1.5
                            }}>
                                직원이 결제 내역 확인 후<br />처리 예정입니다
                            </div>
                        </div>
                    </div>
                </div>
            }




            <div className={styles.void} style={{
                height: "50px"
            }}>

            </div>


            <Modal
                aria-labelledby="modal-title"
                aria-describedby="modal-desc"
                open={open}
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                <Sheet
                    variant="outlined"
                    sx={{ maxWidth: 350, borderRadius: 'md', p: 3, boxShadow: 'lg' }}
                >
                    <Typography
                        component="h2"
                        id="modal-title"
                        textColor="inherit"
                        sx={{ fontWeight: 'lg', mb: 1 }}
                    >
                        {text}
                    </Typography>
                </Sheet>
            </Modal>



        </div>
    )
}

export default RegisterLink;